export const styles = {
  container: {
    display: 'flex',
    alignItems: 'center',
    flexDirection: 'column',
    paddingTop: 30,
    paddingLeft: 20,
    paddingRight: 20,
    position: 'relative',
  },
  loaderContainer: {
    position: 'absolute',
    top: 30,
    right: -10,
  },
  title: {
    fontSize: 24,
    fontFamily: "'Proxima Nova Alt', sans-serif",
    color: 'black',
    fontWeight: '700',
    textAlign: 'center',
    marginBottom: 16,
    width: '100%',
  },
  description: {
    fontSize: 14,
    fontFamily: "'Proxima Nova Alt', sans-serif",
    color: '#707087',
    textAlign: 'center',
    marginBottom: 24,
    lineHeight: 1.5,
    width: '100%',
  },
  bodyContainer: {
    display: 'flex',
    width: '100%',
    justifyContent: 'space-between',
    height: 36,
    marginTop: 16,
    marginBottom: 26,
  },
  selectTitle: {
    fontSize: 16,
    fontFamily: "'Proxima Nova Alt', sans-serif",
    display: 'flex',
    alignItems: 'center',
  },
  inputRoot: {
    '& .MuiInput-underline:before': {
      display: 'none',
    },
    '& .MuiInput-underline:after': {
      display: 'none',
    },
    '& .MuiInput-root': {
      width: 286,
      height: 36,
      paddingLeft: 14,
      border: '1px solid #E2E2FC',
      borderRadius: 4,
    },
  },
  datePicker: {
    marginTop: -14,
  },
  buttonContainer: {
    display: 'flex',
    justifyContent: 'space-between',
    marginTop: 32,
    marginBottom: 20,
    width: '100%',
  },
  cancelButton: {
    minWidth: 120,
  },
  submitButton: {
    minWidth: 120,
  },
}
